export enum VehicleTypeEnum {
    TRUCK = "TRUCK",
    TROLLEY = "TROLLEY",
    MOVER = "MOVER"
}